import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import Post from "./sections/Post"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <Post />
      <Footer />
    </div>
  )
}
